// RUNN — 16+ age assurance (logic only; UI lives in consent-banner.js).
// Uses a NEUTRAL date-of-birth challenge (not a yes/no) per regulator guidance.
// We store only a pass flag + coarse age bracket — never the raw birth date.
import { APP_MIN_AGE } from './regions.js';

const LS_KEY = 'runn.age.v1';

export function isAgeVerified() {
  try {
    const r = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
    return !!(r && r.ok);
  } catch {
    return false;
  }
}

export function ageFromDOB(year, month, day) {
  const today = new Date();
  let age = today.getFullYear() - year;
  const hadBirthday =
    today.getMonth() + 1 > month ||
    (today.getMonth() + 1 === month && today.getDate() >= day);
  if (!hadBirthday) age -= 1;
  return age;
}

export function bracketFor(age) {
  if (age == null || Number.isNaN(age)) return 'unknown';
  if (age < APP_MIN_AGE) return 'under16';
  if (age < 18) return '16-17';
  if (age < 25) return '18-24';
  if (age < 35) return '25-34';
  if (age < 50) return '35-49';
  return '50+';
}

export function recordAge(pass, age) {
  try {
    localStorage.setItem(
      LS_KEY,
      JSON.stringify({ ok: !!pass, bracket: bracketFor(age), at: new Date().toISOString() })
    );
  } catch {
    /* noop */
  }
}

export function ageBracket() {
  try {
    return JSON.parse(localStorage.getItem(LS_KEY) || 'null')?.bracket || 'unknown';
  } catch {
    return 'unknown';
  }
}

/** Validate a DOB selection; returns { ok, age, reason }. */
export function evaluateDOB(year, month, day) {
  if (!year || !month || !day) return { ok: false, age: null, reason: 'incomplete' };
  const y = Number(year), m = Number(month), d = Number(day);
  const test = new Date(y, m - 1, d);
  const valid = test.getFullYear() === y && test.getMonth() === m - 1 && test.getDate() === d;
  if (!valid) return { ok: false, age: null, reason: 'invalid-date' };
  const age = ageFromDOB(y, m, d);
  if (age < 0 || age > 120) return { ok: false, age: null, reason: 'invalid-date' };
  return { ok: age >= APP_MIN_AGE, age, reason: age >= APP_MIN_AGE ? 'ok' : 'underage' };
}
